import { Box, Text, useMantineTheme } from '@mantine/core';
import { PrimaryButton } from './PrimaryButton';

type ScheduleCallProps = {
  onClick: () => void;
};

const ScheduleCall = ({ onClick }: ScheduleCallProps) => {
  const theme = useMantineTheme();

  return (
    <Box
      p="xl"
      w="88%"
      style={{
        border: '1px solid #FFFFFF29',
        borderRadius: theme.radius.md,
      }}
    >
      <Text
        w="100%"
        align="center"
        color={theme.colors.minor[1]}
      >
        Would you rather speak with a dedicated representative?
        <br />
        Schedule a 15-minute consultation instead.
      </Text>
      <PrimaryButton
        bg="tertiary.4"
        type="button"
        fullWidth
        m="0 auto"
        styles={(theme) => ({
          root: {
            boxShadow: '0px 2px 4px 0px #2E193E1A',
            color: theme.colors.minor[1],
          },
        })}
        onClick={onClick}
      >
        Schedule a Call
      </PrimaryButton>
    </Box>
  );
};

export default ScheduleCall;
